import { render, staticRenderFns } from "./ExportData.vue?vue&type=template&id=6c6f4f5c&scoped=true&"
import script from "./ExportData.vue?vue&type=script&lang=js&"
export * from "./ExportData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6f4f5c",
  null
  
)

export default component.exports